import { render } from "./SoftSpinner.vue?vue&type=template&id=0742b580&scoped=true"
const script = {}

import "./SoftSpinner.vue?vue&type=style&index=0&id=0742b580&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0742b580"]])

export default __exports__